// noinspection JSUnusedGlobalSymbols

import {ExceptionsCollector} from '@/exceptions/ExceptionsCollector';
import {VanillaException} from '@/exceptions/VanillaException';
import {LoginUserStates} from '@/enums/LoginUserStates.enum';

export namespace AuthenticatorExceptions {
    export class TooManyLoginAttemptsException extends VanillaException {
        static {
            ExceptionsCollector.registerException('AuthenticatorExceptions', this);
        }

        constructor() {
            super('AuthenticatorExceptions', 'Zu viele Anmeldeversuche', 'Für dieses Profil wurden zu viele Anmeldeversuche unternommen. Bitte kontaktiere den Service, um dein Konto zu entsperren.', 403);
        }
    }

    export class InvalidCredentialsException extends VanillaException {
        static {
            ExceptionsCollector.registerException('AuthenticatorExceptions', this);
        }

        constructor() {
            super('AuthenticatorExceptions', 'Ungültige Zugangsdaten', 'Die bereitgestellten Zugangsdaten passen zu keinem Konto in Vanilla. Bitte prüfe den Nutzernamen und das Passwort.', 403);
        }
    }

    export class InactiveLoginException extends VanillaException {
        static {
            ExceptionsCollector.registerException('AuthenticatorExceptions', this);
        }

        constructor(state: LoginUserStates) {
            let desc: string;
            switch (state) {
                case LoginUserStates.INACTIVE:
                    desc = 'Dein Konto wurde deaktiviert. Kontaktiere deine Ansprechperson, um dein Konto zu reaktivieren.';
                    break;
                case LoginUserStates.DRAFT:
                    desc = 'Dein Konto wurde noch nicht aktiviert. Bitte kontaktiere deine Ansprechperson, um dein Konto zu aktivieren.';
                    break;
                default:
                    desc = 'Dein Konto wurde aus unbekannten Gründen deaktiviert. Kontaktiere deine Ansprechperson, um dein Konto zu reaktivieren.';
                    break;
            }
            super('AuthenticatorExceptions', 'Inaktives Konto', desc, 403);
        }
    }
}
